<template>
    <div class="container-fluid mt-5">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Total de Consultas Realizadas</h3>
                <p class="text-muted">Actualmente son todas las consultas que has atendido.</p>
            </div>
            <div class="col-md-12 text-center">
                <div v-if="isLoading">
                    <vs-spinner color="rgb(59,222,200)" />
                </div>
                <div v-else>
                    <apexchart type="radialBar" :options="chartOptions" :series="[100]" height="250" />
                    <div class="total-consultas-number">{{ totalConsultas }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "TotalConsultas",
    components: {
        apexchart: VueApexCharts
    },
    props: {
        personal_medico_id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            totalConsultas: 0,
            chartOptions: {
                chart: {
                    type: "radialBar"
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: "70%"
                        },
                        dataLabels: {
                            show: false // Ocultar las etiquetas del gráfico
                        }
                    }
                },
                colors: ["#3bdec8"]
            }
        };
    },
    mounted() {
        this.fetchTotalConsultas();
    },
    methods: {
        async fetchTotalConsultas() {
            try {
                const response = await axios.get(`${API}/consultas_concretadas`, {
                    params: {
                        personal_medico_id: this.personal_medico_id
                    }
                });

                if (response.data.status === "success") {
                    this.totalConsultas = response.data.data.total_consultas;
                } else {
                    this.notify("error", "No se pudo obtener el total de consultas.");
                }
            } catch (error) {
                console.error(error);
                this.notify("error", `Error: ${error.response?.data?.message || error.message}`);
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.text-main-gradient {
    background: linear-gradient(to right, #3bdec8, #59bfff);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.total-consultas-number {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 36px;
    font-weight: bold;
    color: #3bdec8;
}
</style>
